import type {AuditParamDefinitions} from './AuditParamDefinitions';

export type BasicCategoryOfStructure = {
  name: Record<string, string>;
  asTitle: boolean;
  key: string | null;
  id: string;
  childCategories: Array<BasicCategoryOfStructure> | null;
  paramDefinitions: AuditParamDefinitions | null;
  icon: string | null;
  featureKey: string | null;
  uniqueKey: string;
};
